export default __webpack_public_path__ + "static/media/ic-delete.ae91b14b.svg";